import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";
import { ContentLog, ContentLogsResponse } from "../types/dashboard";

const useBrandHistoryApi = () => {
  const { get, post } = useHttpAdapter();

  const getBrandHistory = useCallback(
    async (
      brandId: string,
      offset: number,
      limit: number,
      reconcile: boolean = false
    ): Promise<{ list: ContentLog[]; count: number }> => {
      try {
        const response = await get<ContentLogsResponse>(
          `/brand/history/${brandId}?offset=${offset}&limit=${limit}${
            reconcile ? "&reconcile=true" : ""
          }`
        );
        return {
          list: response.data.data,
          count: response.data.total_logs,
        };
      } catch (e) {
        return {
          list: [],
          count: 0,
        };
      }
    },
    [get]
  );

  const getBrandHistoryByMonth = useCallback(
    async (
      brandId: string,
      month: number,
      year?: number,
      reconcile: boolean = false
    ): Promise<ContentLog[]> => {
      try {
        const response = await get<ContentLogsResponse>(
          `/brand/history/${brandId}/month/${month}${
            year != null ? `?year=${year}` : "?"
          }${
            reconcile
              ? `${year != null ? "&" : ""}reconcile=true`
              : ""
          }`
        );
        return response.data.data;
      } catch (e) {
        return [];
      }
    },
    [get]
  );

  const triggerBrandHistoryReconcile = useCallback(
    async (brandId: string): Promise<boolean> => {
      try {
        const response = await post<{ status: string }>(
          `/brand/history/${brandId}/reconcile`
        );
        return response.status >= 200 && response.status < 300;
      } catch {
        return false;
      }
    },
    [post]
  );

  return {
    getBrandHistory,
    getBrandHistoryByMonth,
    triggerBrandHistoryReconcile,
  };
};

export default useBrandHistoryApi;
